/**
 * Fragment de routes du paquet v1-p05-coquille (vague V1). Données et composants chargés à la demande seulement
 * (règle de chargement du registre) ; actif sans condition depuis le retrait du drapeau `navigationV10` (R3, 02/11) :
 *  - `coquille` : LA coquille de l'application (barre haute, barres latérales des niveaux, aide, page d'erreur, compte
 *    sans organisation) ;
 *  - `connexion` : l'écran de connexion ;
 *  - `publiques` : `/activation` (activation du compte), rendue avec ou sans session.
 * Aucune route privée : les écrans du paquet sont la coquille elle-même ; les entrées de navigation pointent vers les
 * routes existantes (`ecrans/v1/coquille/cibles.generated.ts`).
 */
import { lazy } from 'react'

import type { FragmentRoutes } from './registre'

const Coquille = lazy(() => import('../ecrans/v1/coquille/Coquille'))
const Connexion = lazy(() => import('../ecrans/v1/coquille/Connexion'))
const ActivationCompte = lazy(() => import('../ecrans/v1/coquille/ActivationCompte'))

export const fragment: FragmentRoutes = {
  zone: 'v1-coquille',
  routes: [],
  publiques: [{ chemin: '/activation', ecran: ActivationCompte }],
  coquille: Coquille,
  connexion: Connexion,
}
